/**
 * Copyright 2020-2024, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export function isHoldout(obj) {
    // Holdout doesn't have 'layerId' property, while Experiment does
    return obj.layerId === undefined;
}
export var VariableType;
(function (VariableType) {
    VariableType["BOOLEAN"] = "boolean";
    VariableType["DOUBLE"] = "double";
    VariableType["INTEGER"] = "integer";
    VariableType["STRING"] = "string";
    VariableType["JSON"] = "json";
})(VariableType || (VariableType = {}));
//TODO: Move OptimizelyDecideOption to @optimizely/optimizely-sdk/lib/utils/enums
export var OptimizelyDecideOption;
(function (OptimizelyDecideOption) {
    OptimizelyDecideOption["DISABLE_DECISION_EVENT"] = "DISABLE_DECISION_EVENT";
    OptimizelyDecideOption["ENABLED_FLAGS_ONLY"] = "ENABLED_FLAGS_ONLY";
    OptimizelyDecideOption["IGNORE_USER_PROFILE_SERVICE"] = "IGNORE_USER_PROFILE_SERVICE";
    OptimizelyDecideOption["INCLUDE_REASONS"] = "INCLUDE_REASONS";
    OptimizelyDecideOption["EXCLUDE_VARIABLES"] = "EXCLUDE_VARIABLES";
    OptimizelyDecideOption["IGNORE_CMAB_CACHE"] = "IGNORE_CMAB_CACHE";
    OptimizelyDecideOption["RESET_CMAB_CACHE"] = "RESET_CMAB_CACHE";
    OptimizelyDecideOption["INVALIDATE_USER_CMAB_CACHE"] = "INVALIDATE_USER_CMAB_CACHE";
})(OptimizelyDecideOption || (OptimizelyDecideOption = {}));
export const __platforms = ['__universal__'];
//# sourceMappingURL=shared_types.js.map